import React, { useCallback, useEffect } from 'react'
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Tab } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { StyledTabWrapper, StyledTabPane } from '../../style'
import LanguageForm from './LanguageForm'

interface DocumentsComponentProps {
  languages: any[],
  types: any[],
  type: string,
  label: string
}

const DocumentsComponent: React.FunctionComponent<DocumentsComponentProps> = (props) => {
  const { control, getValues } = useFormContext()
  const { t } = useTranslation()
  const { label } = props
  const indexOfTerms = getValues('documents').findIndex((item: any) => item.type === props.type)
  const watchStatus = useWatch({ control, name: `documents[${indexOfTerms}].status` })

  const { fields } = useFieldArray({
    control,
    name: `documents[${indexOfTerms}].languages`,
    keyName: 'key'
  })

  function renderLanguageFields() {
    return <Tab
      menu={{ secondary: true, pointing: true }}
      renderActiveOnly={false}
      panes={
        props.languages.map((language) => {
          const languages = fields || []
          const indexLanguage = languages.findIndex(languageIndex => languageIndex['id'] === language.id)
          return {
            //@ts-ignore
            menuItem: language['label'],
            pane: <StyledTabPane key={fields[indexLanguage].key}>
              <LanguageForm
                index={indexLanguage}
                key={fields[indexLanguage].key}
                indexOfTerms={indexOfTerms}
                types={props.types}
              />
            </StyledTabPane>
          }
        })}
    />
  }

  function renderForm() {
    return <>
      <FormFields.Checkbox
        control={control}
        defaultValue={0}
        checkboxValue={1}
        label={t('Activate {{label}}?', { label })}
        name={`documents[${indexOfTerms}].status`}
      />
      {renderLanguageFields()}
    </>
  }

  return <StyledTabWrapper>
    {renderForm()}
  </StyledTabWrapper>
}
export default DocumentsComponent
